import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

type Config = Required<Pick<AST.SubExpression, 'hash' | 'params' | 'path'>> &
  Partial<AST.SubExpression>;

export const createSubExpression = (config: Config): AST.SubExpression => ({
  loc,
  type: NodeType.SubExpression,
  ...config,
});
